import BackgroundIcon from '@hellodarwin/app-core/lib/layouts/page-layout/components/BackgroundIcon';
import useMediaQuery from '@hellodarwin/core/lib/features/helpers/use-media-query';
import { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { PreviewContent } from '../../../data/steps-content';
import useOnboardingFlow from '../../../hooks/useOnboardingFlow';
import OnboardingLayoutFormContainer from './form-container';
import OnboardingLayoutPreviewContainer from './preview-container';
import { ContentBody, ContentContainer } from './styles';

interface OnboardingLayoutPageContainerProps {
  handleFormChange: () => void;
}
const OnboardingLayoutPageContainer: React.FC<
  OnboardingLayoutPageContainerProps
> = ({ handleFormChange }) => {
  const theme = useTheme();
  const { currentStepContent, stepData } = useOnboardingFlow();
  const { previewContent } = currentStepContent ?? {};
  const [previewType, setPreviewType] = useState<PreviewContent>(
    previewContent ?? 'picture',
  );
  const isMediumDesktop = useMediaQuery({ maxWidth: theme.breakpoints.l });
  const isMobile = useMediaQuery({ maxWidth: theme.breakpoints.mobile });

  useEffect(() => {
    if (!currentStepContent || !stepData) return;

    if (isMediumDesktop) {
      if (!!currentStepContent.previewContentTablet) {
        setPreviewType(currentStepContent.previewContentTablet);
      } else {
        if (!!currentStepContent.previewContent) {
          setPreviewType(currentStepContent.previewContent);
        } else {
          setPreviewType('none');
        }
      }
    } else {
      if (!!currentStepContent.previewContent) {
        setPreviewType(currentStepContent.previewContent);
      } else {
        setPreviewType('none');
      }
    }
    if (isMobile || isMediumDesktop) {
      setPreviewType('none');
    }
  }, [stepData, currentStepContent, isMediumDesktop, isMobile]);

  return (
    <ContentContainer>
      <div
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          zIndex: 0,
        }}
      >
        <BackgroundIcon
          iconParams={{
            side: 'right',
            icon: 'Group1Filled',
            color: theme.colors.beige_4,
            top: 10,
            margin: -300,
            width: 900,
            height: 800,
          }}
        />
      </div>
      <ContentBody $previewContent={previewType}>
        <OnboardingLayoutFormContainer handleFormChange={handleFormChange} />

        <OnboardingLayoutPreviewContainer previewType={previewType} />
      </ContentBody>
    </ContentContainer>
  );
};

export default OnboardingLayoutPageContainer;
